<h5 mat-dialog-title>Bearbeiten</h5>
<app-image-detail-form [imageData]="data"></app-image-detail-form>
<div class="flex-justify-center" mat-dialog-actions>
  <button mat-dialog-close mat-raised-button>Schliessen</button>
</div>
